import Modal from 'ageas-react-component-modal'
import PageTitle from 'ageas-react-component-pagetitle'

import { MainContainer } from '../../GlobalStyles'
import { t } from '../../i18n'
import { ModalComponent } from '../ModalComponent'
import { Tab } from '../Tab'
import { Addresses } from './Addresses'
import { Contacts } from './Contacts'
import { Identification } from './Identification'
import { StandardContainer } from './style'

type CreateEntityProps = {
  isVisible: boolean
  closeAction?: () => void
}

export function EntityDetails({
  isVisible,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  closeAction = () => {},
}: CreateEntityProps) {
  return (
    <ModalComponent show={isVisible}>
      <Modal
        show={isVisible}
        hideCloseAction={false}
        closeAction={closeAction}
        content={
          <MainContainer>
            <StandardContainer>
              <PageTitle
                id="EntityDetails"
                name={t('pages.step3.entityDetails')}
              />
              <Tab
                tabs={[
                  t('pages.step3.tabs.identification'),
                  t('pages.step3.tabs.addresses'),
                  t('pages.step3.tabs.contacts'),
                ]}
                pages={[
                  <Identification key="identification" />,
                  <Addresses key="addresses" />,
                  <Contacts key="contacts" />,
                ]}
              />
            </StandardContainer>
          </MainContainer>
        }
      />
    </ModalComponent>
  )
}
